import apiClient from 'services/axios'
import store from 'store'

export async function login(email, password) {
  return apiClient
    .post('/agent/login', {
      email,
      password,
    })
    .then(response => {
      if (response) {
        const { accessToken } = response.data.data
        if (accessToken) {
          store.set('accessToken', accessToken)
        }
        return response.data
      }
      return false
    })
    .catch(err => console.log(err))
}

export async function register(email, password, name) {
  return apiClient
    .post('/register/agent', {
      email,
      password,
      name,
    })
    .then(response => {
      if (response) {
        const { accessToken } = response.data
        if (accessToken) {
          store.set('accessToken', accessToken)
        }
        return response.data
      }
      return false
    })
    .catch(err => console.log(err))
}

export async function currentAccount() {
  return apiClient
    .get('/agent/me')
    .then(response => {
      if (response) {
        const { accessToken } = response.data
        if (accessToken) {
          store.set('accessToken', accessToken)
        }
        return response.data
      }
      return false
    })
    .catch(err => console.log(err))
}

export async function renewToken(refreshToken) {
  return apiClient.post('/agent/renewToken', { refreshToken }).then(response => {
    if (response) {
      const { accessToken } = response.data.data
      if (accessToken) {
        store.set('accessToken', accessToken)
      }
      return response.data
    }
    return false
  })
}

export async function logout() {
  return store.clearAll()
}
